import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DateDeserializationInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request and modify the body to convert Date objects to SimpleDate objects
    const modifiedReq = req.clone({
      body: this.convertDatesToSimpleDate(req.body),
    });

    return next.handle(modifiedReq).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          // Check if the response body is an object and iterate through its properties
          if (typeof event.body === 'object' && event.body !== null) {
            this.convertSimpleDateToDate(event.body);
          }
        }
        return event;
      })
    );
  }

  private convertSimpleDateToDate(obj: object): void {
    // Iterate over the keys of the object
    for (const key in obj) {
      if (this.hasProperty(obj, key)) {
        const value = obj[key];
        if (value === null) continue;
        // Look for a SimpleDate and convert it
        if (
          typeof value === 'object' &&
          this.hasProperty(value, 'Year') &&
          this.hasProperty(value, 'Month') &&
          this.hasProperty(value, 'Day') &&
          this.hasProperty(value, 'Hour') &&
          this.hasProperty(value, 'Minute') &&
          this.hasProperty(value, 'Second') &&
          Object.keys(value).length == 6
        ) {
          if (
            typeof value['Year'] === 'number' &&
            typeof value['Month'] === 'number' &&
            typeof value['Day'] === 'number' &&
            typeof value['Hour'] === 'number' &&
            typeof value['Minute'] === 'number' &&
            typeof value['Second'] === 'number'
          ) {
            obj[key] = new Date(value['Year'], value['Month'] - 1, value['Day'], value['Hour'], value['Minute'], value['Second']); // Convert to Date
          }
        }
        // If it's an object, recursively check for nested date fields
        else if (typeof value === 'object') {
          this.convertSimpleDateToDate(value); // Recursively handle nested objects
        }
      }
    }
  }

  private convertDatesToSimpleDate(obj: object): object {
    if (obj === null || obj === undefined) {
      return obj;
    }

    if (obj instanceof Date) {
      return {
        Year: obj.getFullYear(),
        Month: obj.getMonth() + 1,
        Day: obj.getDate(),
        Hour: 0,
        Minute: 0,
        Second: 0,
      };
    }

    if (typeof obj === 'object') {
      for (const key in obj) {
        if (this.hasProperty(obj, key)) {
          obj[key] = this.convertDatesToSimpleDate(obj[key]);
        }
      }
    }

    return obj;
  }

  private hasProperty(obj: object, key: string): boolean {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }
}
